import { makeStyles } from '@material-ui/core';

export default makeStyles({
  image: {
    maxWidth: '100%',
  },
});
